var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.show
        ? _c("div", { class: _vm.slideInClass }, [
            _c(
              "header",
              [
                _c("div", { staticClass: "title-container" }, [
                  _c("div", [
                    _c("h4", {
                      domProps: { innerHTML: _vm._s(_vm.computedTitle) }
                    }),
                    _vm._v(" "),
                    _vm.subTitle
                      ? _c("h3", {
                          domProps: { innerHTML: _vm._s(_vm.subTitle) }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "close-container" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.closeFan(false)
                          }
                        }
                      },
                      [_c("Icon", { attrs: { icon: "close" } })],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.headerInfo === _vm.headerInfos.applicationNoExperience
                  ? _c("NoExperienceInfo")
                  : _vm._e(),
                _vm._v(" "),
                _vm.withKeyword
                  ? _c(
                      "div",
                      { staticClass: "characteristic-fan--search" },
                      [
                        _c("SearchInput", {
                          attrs: {
                            "characteristic-type": _vm.characteristicType,
                            placeholder:
                              _vm.keywordPlaceholder ||
                              "Suche... (mind. 3 Zeichen)",
                            catalog: _vm.searchConfig
                              ? _vm.searchConfig.catalog
                              : undefined
                          },
                          model: {
                            value: _vm.keyword,
                            callback: function($$v) {
                              _vm.keyword = $$v
                            },
                            expression: "keyword"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "main",
              { staticClass: "scrollbar-check" },
              [
                _vm.isNothingAllowedOverallInline
                  ? _c(
                      "div",
                      { staticClass: "characteristic-fan--nothing-allowed" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              checked: _vm.isNothingAllowedOverallChecked
                            },
                            on: { change: _vm.onNothingAllowedOverallChanged }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.nothingAllowedOverallText) +
                                "\n\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "characteristic-fan--items-info" },
                          [
                            _vm.showMultipleHint
                              ? [
                                  _vm._v("Oder "),
                                  _c("b", [_vm._v("Mehrfachauswahl")]),
                                  _vm._v(" möglich:")
                                ]
                              : [_vm._v("Oder wähle aus:")]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : !_vm.isNothingAllowed && _vm.showMultipleHint
                  ? _c(
                      "div",
                      { staticClass: "characteristic-fan--items-info" },
                      [
                        _c("b", [_vm._v("Mehrfachauswahl")]),
                        _vm._v(" möglich:\n\t\t\t")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isNothingAllowed && _vm.sourceCharacteristic
                  ? _c("CharacteristicItem", {
                      attrs: {
                        characteristic: _vm.sourceCharacteristic,
                        level: 1,
                        nothing: ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.itemsGroupedByLetter, function(itemGroup) {
                  return _c(
                    "div",
                    { key: itemGroup.id },
                    [
                      itemGroup.separation
                        ? _c("Separation", {
                            staticClass: "items-separation",
                            attrs: { separation: itemGroup.separation }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(itemGroup.items, function(
                        characteristics,
                        letter
                      ) {
                        return _c(
                          "div",
                          { key: letter, staticClass: "letter-section" },
                          [
                            _c("div", { staticClass: "letter" }, [
                              _vm._v(_vm._s(letter))
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "items" },
                              _vm._l(characteristics, function(characteristic) {
                                return _c("CharacteristicItem", {
                                  key: characteristic.id,
                                  attrs: {
                                    characteristic: characteristic,
                                    level: 1,
                                    keyword: _vm.hasValidKeyword
                                      ? _vm.keyword
                                      : undefined
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "footer",
              [
                _c("Button", {
                  attrs: {
                    text: "OK",
                    disabled: !_vm.valid,
                    icon: "checkmark"
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeFan(true)
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.fanParents, function(parent, i) {
        return _c("Parent", {
          key: parent.id,
          attrs: { characteristic: parent, level: i + 2 }
        })
      }),
      _vm._v(" "),
      _vm.showCompletionCheckPopUp
        ? _c("CompletionCheckPopUp", {
            attrs: {
              title: _vm.completionCheckConfig.label,
              "ok-button-text": _vm.completionCheckConfig.okButtonText
            },
            on: {
              abort: function($event) {
                _vm.showCompletionCheckPopUp = false
              },
              skip: function($event) {
                return _vm.closeFan(true, true)
              },
              ok: function($event) {
                return _vm.closeFan(true, false)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "info",
                  fn: function() {
                    return [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.completionCheckConfig.popUpInfo)
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1629443093
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }